<template>
  <div>
    <br />

    <app-history
      title="ارسال درخواست"
      @clicked="$router.push('/talabbos-request')"
    />

    <app-history @clicked="$router.push('/talabbos-history')" />
    <app-history title="تایید تلبس طلاب" @clicked="checkConfirm" />
  </div>
</template>

<script>
import { hasConfirmPermission } from "@/api/talabbos";

import HistoryButton from "@/components/HistoryButton";
export default {
  data() {
    return {};
  },
  components: {
    appHistory: HistoryButton,
  },
  computed: {
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
  },
  methods: {
    /**
     * send request
     */
    openZavabet() {
      window.open("https://hozehkh.com/res/talabbos.pdf");
    },
    checkConfirm() {
     

      return new Promise((resolve, reject) => {
        hasConfirmPermission()
          .then((response) => {
            if (response.data) {
              this.$router.push("/talabbos-confirm");
            } else {
              this.$store.commit("SET_SNACKBAR_TEXT", "تایید تلبس برای اساتید سطح 2 و بیشتر مجاز است.");
            }
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px !important;
}

.request {
  width: 300px !important;
  margin: 15px;
}
.register {
  width: 300px !important;
  margin: 15px auto;
}
@media only screen and (min-width: 600px) {
  .form {
    width: 570px;
    margin: 15px auto;
  }

  .col-12 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}
</style>
